import { IState } from 'legacy/lut/store'

export const selectWelcomeFlowState = (state: IState) => state.partner360.welcomeFlow
